import { EmbedDesignStudioRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/design-studio-embed/cio/$')({
  component: EmbedDesignStudioRoute,
});
